<template>
    <div>
        <van-nav-bar
            title="我的提单"
            left-text=""
            right-text="筛选"
            left-arrow
            fixed
            @click-left="back()"
            @click-right="searchPop()"
            v-if="show"
        />
<!--            z-index="9999"-->
        <van-nav-bar
                title="提单详情"
                left-arrow
                fixed
                v-if="showpop"
                @click-left="showpop=false"
                z-index="9999"
        />
        <van-button v-if="showpop" class="closebutton" block size="small" type="info" native-type="submit" style="font-size: 16px;width:100%;margin:auto" @click="closeShow()">
            关闭
        </van-button>

        <van-nav-bar
                title="提单明细"
                left-arrow
                fixed
                v-if="showDetailpop"
                @click-left="showDetailpop=false"
                z-index="9999"
        />
        <van-button v-if="showDetailpop" class="closebutton" block size="small" type="info" native-type="submit" style="font-size: 16px;width:100%;margin:auto" @click="closeDetailShow()">
            关闭
        </van-button>
        <van-nav-bar
                title="质保书"
                left-arrow
                fixed
                v-if="showWarrantypop"
                @click-left="showWarrantypop=false"
                z-index="9999"
        />
        <van-button v-show="showWarrantypop" class="closebutton" block size="small" type="info" native-type="submit" style="font-size: 16px;width:100%;margin:auto" @click="closeWarrantyShow()">
            关闭
        </van-button>



        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh"  >
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
<!--                    <van-swipe-cell>-->
                        <van-cell   @click="showBill(item)"  v-for="item in list" :key="item.id" class="swipewarp">
                            <van-row gutter="20">
                                <van-col span="14" style="">{{item.outnotifyNo}}</van-col>
                                <van-col span="10" style="text-align: right;word-break:keep-all;white-space:nowrap;">
                                    <span v-if="showStatus(item)=='done'">完结</span>
                                    <span v-else-if="showStatus(item)=='unpay'">{{showMoney(item.balanceAmount)}}<span style="margin-left: 3px">元</span> <a style="color:#6685a4;margin-left: 10px">待结算</a></span>
                                    <span v-else-if="showStatus(item)=='pay'">审核</span>
                                </van-col>
                            </van-row>
                            <van-row gutter="20" style="color: #727272">
                                <van-col span="14" style="word-break:keep-all;white-space:nowrap;">{{item.customerName}}</van-col>
                                <van-col span="10" style="text-align: right">{{item.outnotifyCustomerNo}}</van-col>
                            </van-row>
                            <van-row gutter="20"  v-for="cargoitem in item.cargo" :key="cargoitem.cargoName" style="color: #727272">
                                <van-col span="14"  style="">{{cargoitem.cargoName}}</van-col>
                                <van-col span="10" style="text-align: right;">{{cargoitem.amount}}<span style="margin-left: 3px">件</span>，{{cargoitem.weight}}<span style="margin-left: 3px">吨</span></van-col>
                            </van-row>
                        </van-cell>
<!--                        <template #right>-->
<!--                            <van-button plain  type="danger" text="删除" @click="remove(item.id)"/>-->
<!--                        </template>-->
<!--                    </van-swipe-cell>-->

                </van-list>
            </van-pull-refresh>
        </div>

        <van-popup v-model="ershow" :lazy-render=false position="right" :style="{ height: '100%', width:'100%'}" >


                    <div id="qrCode"  class="qrcode" ref="qrCodeDiv"   style="margin:150px auto;width: 200px"></div>


        </van-popup>

        <van-popup v-model="showpop" position="right" :style="{ height: '100%', width:'100%'}" >

            <div class="editwarp">
                <van-cell  class="swipewarp">
                    <van-row gutter="20">
                        <van-col span="8"><span class="detailLabel detailtitle">{{outnotify.outnotifyNo}}</span></van-col>
                        <van-col span="16" style="text-align: right">
                            <span v-if="showDetailStatus(outnotify)=='done '" >完结</span>
                            <span v-else-if="showDetailStatus(outnotify)=='verify'">审核</span>
                        </van-col>
                    </van-row>
<!--                    <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0' }"/>-->

                    <van-row gutter="20">
                        <van-col span="6"><span class="detailLabel">通知日期</span></van-col>
                        <van-col span="18" style="text-align: right">{{outnotify.outnotifyDate}}</van-col>
                    </van-row>
                    <van-row gutter="20">
                        <van-col span="4"><span class="detailLabel">货主</span></van-col>
                        <van-col span="20" style="text-align: right">{{outnotify.customerName}}</van-col>
                    </van-row>
                    <van-row gutter="20">
                        <van-col span="6"><span class="detailLabel">货主提单号</span></van-col>
                        <van-col span="18" style="text-align: right">{{outnotify.outnotifyCustomerNo}}</van-col>
                    </van-row>
                    <van-row gutter="20">
                        <van-col span="6"><span class="detailLabel">提货仓库</span></van-col>
                        <van-col span="18" style="text-align: right">{{outnotify.orgunitName}}</van-col>
                    </van-row>
                    <van-row gutter="20"  style="text-align: center" class="ewm">
                        <van-button type="info" @click="shower(outnotify);"  style="margin-top:5px">二维码</van-button>
                    </van-row>
                </van-cell>
                <van-cell  class="swipewarp">
                    <van-row gutter="20" style="padding-bottom: 10px">
                        <van-col span="8"><span class="detailLabel detailtitle">提货明细</span></van-col>
                        <van-col span="16" style="text-align: right"><a type="info" style="color:#6685a4" @click="showDetail"><van-icon name="arrow" /></a></van-col>
                    </van-row>
                    <div  v-for="cargoitem in outnotify.cargo" :key="cargoitem.cargoName" class="thmx">
                        <van-divider :style="{ color: '#e2e2e2', borderColor: '#e2e2e2', padding: '0 0 0 0px' }"/>
                        <van-row >
                            <van-col span="10"  style="line-height: 48px">{{cargoitem.cargoName}}</van-col>
                            <van-col span="14" style="text-align: right">
                                <van-row >
                                    <van-col style="float: right">应发：{{cargoitem.amount}}<span style="margin-left: 3px">件</span>，{{cargoitem.weight}}<span style="margin-left: 3px">吨</span></van-col>
                                    <van-col style="float: right">实发：{{cargoitem.amountOut}}<span style="margin-left: 3px">件</span>，{{cargoitem.weightOut}}<span style="margin-left: 3px">吨</span></van-col>
                                </van-row>
                            </van-col>
                        </van-row>

                    </div>
                </van-cell>
                <van-cell  class="swipewarp">
                    <van-row gutter="20">
                        <van-col span="12"><span class="detailLabel detailtitle">费用</span></van-col>
                        <van-col span="12" style="text-align: right">
                            {{showMoney(outnotify.balanceAmount)}}<span style="margin-left: 3px">元</span>
                            <span v-if="outnotify.balanceStatus==0"><a style="color:#6685a4;margin-left: 15px">待结算</a></span>
                            <span v-else-if="outnotify.balanceStatus==1"  style="margin-left: 15px">已支付</span>
                        </van-col>
                    </van-row>
                </van-cell>
                <van-cell  class="swipewarp">
                    <van-row gutter="20">
                        <van-col span="12"><span class="detailLabel detailtitle">质保书</span></van-col>
                        <van-col span="12" style="text-align: right">
                            <a @click="showWarrantyBook">{{outnotify.warrantyBook==undefined?0:outnotify.warrantyBook.length}} <van-icon name="arrow" />
                            </a>
                        </van-col>
                    </van-row>

                </van-cell>
            </div>
        </van-popup>

        <van-popup v-model="searchShowPop" position="right" :style="{ height: '100%', width:'80%'}" >
            <van-nav-bar
                    title="筛选"
                    fixed
                    z-index="9999"
            />
            <div class="searchwarp">
                <van-field v-model="searchValue.keywords" label="关键字"  placeholder="请输入单号/货主提单号/货主名称"  autocomplete="off" label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.from" label="提单日期" readonly="readonly"  placeholder="点击选择提单日期"  autocomplete="off" @click="calendarShow=true"  label-width="80px" label-align="right"/>
<!--                <van-field name="radio" label="单选框">-->
<!--                    <template #input>-->
<!--                        <van-radio-group v-model="searchValue.status" direction="horizontal">-->
<!--                            <van-radio name="0">全部</van-radio>-->
<!--                            <van-radio name="20">审核</van-radio>-->
<!--                            <van-radio name="30">完结</van-radio>-->
<!--                        </van-radio-group>-->
<!--                    </template>-->
<!--                </van-field>-->

                <van-field name="text" label="状态" label-width="80px" label-align="right">
                    <template #input>
                        <van-radio-group v-model="searchValue.status" direction="horizontal">
                            <van-button v-if="searchValue.status==0"  hairline type="warning" size="small" @click="searchValue.status=0">全部</van-button>
                            <van-button v-else="" plain hairline type="default" size="small" @click="searchValue.status=0">全部</van-button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <van-button  v-if="searchValue.status==20"  hairline type="warning" size="small" @click="searchValue.status=20" style="margin-left:10px">审核</van-button>
                            <van-button v-else="" plain hairline type="default" size="small" @click="searchValue.status=20" style="margin-left:10px">审核</van-button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <van-button v-if="searchValue.status==30"   hairline type="warning" size="small" @click="searchValue.status=30" style="margin-left:10px">完结</van-button>
                            <van-button  v-else="" plain hairline type="default" size="small" @click="searchValue.status=30" style="margin-left:10px">完结</van-button>
                        </van-radio-group>
                    </template>
                </van-field>


                <van-row gutter="20" style="margin-top:20px">
                    <van-col span="8" offset="4">
                        <van-button  block size="small" type="info" native-type="submit" class="button" @click="resetSearch()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button  block size="small" type="info" native-type="submit" class="button" @click="onSearch()">
                            确定
                        </van-button>
                    </van-col>
                </van-row>

                <van-calendar v-model="calendarShow"
                              :min-date=" new Date(2020, 9, 1)"
                              type="range" @confirm="calendarConfirm" />
            </div>
        </van-popup>

        <van-popup v-model="showDetailpop" position="right" :style="{ height: '100%', width:'100%'}" >
            <van-nav-bar
                    title="提单明细"
                    left-arrow
                    fixed
                    @click-left="showDetailpop=false"
                    z-index="9999"
            />
            <div class="editwarp">
                <van-cell  class="swipewarp">
                    <div v-for="(item,index) in outnotifyDetail" :key="item.id">
                        <van-row gutter="20">
                            <van-col span="14">{{item.cargoName}}\{{item.materialName}}\{{item.modelName}}\{{item.originName}}</van-col>
                            <van-col span="10" style="text-align: right"></van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="14">{{item.cargoFactmodel}}\{{item.batchNumber}}</van-col>
                            <van-col span="10" style="text-align: right">{{item.wCode}}\{{item.aCode}}\{{item.pCode}}\{{item.layer}}</van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="14">应发：{{item.amount}}<span style="margin-left: 3px">件</span>，{{item.weight}}<span style="margin-left: 3px">吨</span></van-col>
                            <van-col span="10" style="text-align: right">实发：{{item.amountOut}}<span style="margin-left: 3px">件</span>，{{item.weightOut}}<span style="margin-left: 3px">吨</span></van-col>
                        </van-row>

                        <van-divider v-if="(index+1)!=outnotifyDetail.length" :style="{ color: '#c2c2c2', borderColor: '#c2c2c2', padding: '10px 0 10px 0' }"/>
                    </div>
                </van-cell>
            </div>
        </van-popup>

        <van-popup v-model="showWarrantypop" position="right" :style="{ height: '100%', width:'100%'}" >
            <van-nav-bar
                    title="质保书"
                    left-arrow
                    fixed
                    @click-left="showWarrantypop=false"
                    z-index="9999"
            />
            <div class="editwarp">

                <van-grid :border="false" :column-num="3">
                    <van-grid-item v-for="item in outnotify.warrantyBook" :key="item.id">
                        <van-image width="100" height="100" lazy-load :src="item" @click="showImg(item)"/>
                    </van-grid-item>

                </van-grid>
            </div>
        </van-popup>

    </div>
</template>

<script>
    import Vue from 'vue'
    import {NavBar, Toast, Cell, Button, Icon, Field, Dialog} from 'vant';
    import {List } from 'vant';
    import {Search  } from 'vant';
    import { Col, Row } from 'vant';
    import {SwipeCell } from 'vant';
    import {Popup } from 'vant';
    import {PullRefresh } from 'vant';
    import {Sticky } from 'vant';
    import { RadioGroup, Radio } from 'vant';
    import { Calendar } from 'vant';
    import {Divider }from 'vant';
    import { Lazyload } from 'vant';
    import service from '../../server/index'
    import { Image as VanImage } from 'vant';
    import { ImagePreview } from 'vant';
    import { Grid, GridItem } from 'vant';
    import QRCode from 'qrcodejs2';
    // Vue.use(Lazyload);

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row .name]: Row ,
            [Cell.name]: Cell,
            [SwipeCell.name ]:SwipeCell,
            [Button.name]:Button,
            [Popup.name]: Popup,
            [Icon.name]:Icon,
            [Field.name]:Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]:Radio,
            [Calendar.name]:Calendar,
            [Divider.name]:Divider,
            [VanImage.name]:VanImage,
            [ImagePreview.Component.name]:ImagePreview.Component,
            [Grid.name]:Grid,
            [GridItem.name]:GridItem
        },
        computed:{
            showStatus(){
                return function(item){
                        if(item.status==30){
                            return "done";
                        }else{
                            if(item.balanceStatus==0){
                                return "unpay";
                            }else{
                                return "pay"
                            }
                        }
                }
            },
            showDetailStatus(){
                return function(item){
                    if(item.status==30){
                        return "done";
                    }else if(item.status==20){
                        return "verify"
                    }
                }
            },
            showMoney(){
                return function (cash){
                    return Math.round((cash + Number.EPSILON) * 100) / 100;
                }
                // cash.toFixed(2);
                // return Math.round((cash + Number.EPSILON) * 100) / 100;
                // return cash.toFixed(2);
            }
        },
        data(){
          return {
              value:"",
              show:true,//nav bar
              showtitle:false,
              ershow:false,
              qrcodeContent:"",
              title:"",
              list: [],
              loading:true,
              finished: false,
              showpop:false,
              searchValue:{
                  keywords:"",
                  startDate:"",
                  endDate:"",
                  status:20,
                  deliveryName:this.$store.username,
                  deliveryIdnumber:this.$store.deliveryIdnumber
              },
              searchShowPop:false,
              //编辑
              info:{
                  "outnotifyNo":"",
                  "balanceAmount":"",
                  "customerName":"",
                  "outnotifyCustomerNo":"",
                  "status":"",
                  "balanceStatus":"",
                  "cargo":[
                      {
                          "cargoName":"",
                          "amount":"",
                          "weight":""
                      }
                  ]
              },
              //刷新
              isLoading:false,
              page:1,
              //日期选择calendarShow
              calendarShow:false,
              //提单详情
              outnotify:{
                  // outnotifyNo:"OU0923131",
                  // outnotifyDate:"2020-10-10",
                  // customerName:"无锡太钢",
                  // outnotifyCustomerNo:"TH0019-11",
                  // balanceAmount:"32.00",
                  // status:30,
                  // balanceStatus:"1",
                  // cargo:[
                  //     {
                  //         cargoName:"铝锭",
                  //         amount:"11",
                  //         weight:"13.1213",
                  //         amountOut:"11",
                  //         weightOut:"13.1213",
                  //     },
                  //     {
                  //         cargoName:"不锈钢板",
                  //         amount:"11",
                  //         weight:"13.1213",
                  //         amountOut:"11",
                  //         weightOut:"13.1213",
                  //     }
                  // ],
                  warrantyBook:[
                  //   "https://img.yzcdn.cn/vant/apple-1.jpg",
                  //     "https://img.yzcdn.cn/vant/apple-2.jpg",
                  //     "https://img.yzcdn.cn/vant/apple-3.jpg",
                  //     "https://img.yzcdn.cn/vant/apple-4.jpg"
                  ]
              },
              //提货明细
              outnotifyDetail:[
                  {
                      id:"1",
                    cargoName:"铝锭",
                      materialName:"99.0",
                      modelName:"Q235B",
                      originName:"太钢",
                      cargoFactmodel:"SJ规格",
                      batchNumber:"123123",
                      pCode:"W10",
                      layer:"11",
                      amount:"1",
                      weight:"1",
                      amountOut:"0",
                      weightOut:"0"
                  },
                  {
                      id:"2",
                      cargoName:"铝锭",
                      materialName:"99.0",
                      modelName:"Q235B",
                      originName:"太钢",
                      cargoFactmodel:"SJ规格",
                      batchNumber:"123123",
                      pCode:"W10",
                      layer:"11",
                      amount:"1",
                      weight:"1",
                      amountOut:"0",
                      weightOut:"0"
                  },
                  {
                      id:"3",
                      cargoName:"铝锭",
                      materialName:"99.0",
                      modelName:"Q235B",
                      originName:"太钢",
                      cargoFactmodel:"SJ规格",
                      batchNumber:"123123",
                      pCode:"W10",
                      layer:"11",
                      amount:"1",
                      weight:"1",
                      amountOut:"0",
                      weightOut:"0"
                  }
              ],
              showDetailpop:false,
              showWarrantypop:false
          }
        },
        mounted() {
            this.onLoad();
        },
        methods:{
            back(){
                this.$router.replace("/Home/HomeMenu")
            },
            shower(data){
                document.getElementById("qrCode").innerHTML = " ";
                //1.获取当前日期
                let m = new Date();

                let n = new Date(m.getTime() + 1000 * 60);
                let date= this.$moment(n).format("YYYY-DD-MM hh:mm:ss");

                let par=[];

                let o = {};
                o.bussionType=data.bussionType
                o.ouid=data.ouid
                // o.bussionNo=data.outnotifyId;
                o.userId=localStorage.getItem("userId");
                o.endTime=date
                par.push( o)
                let str=JSON.stringify(par);
                 console.log(str);
                this.qrcodeContent=this.encode64(str)
                this.bindQRCode();

                this.ershow=true
            },
            encode64(input){
                // base64加密开始
                let keyStr = "ABCDEFGHIJKLMNOP" + "QRSTUVWXYZabcdef" + "ghijklmnopqrstuv"
                    + "wxyz0123456789+/" + "=";
                let output = "";
                let chr1, chr2, chr3 = "";
                let enc1, enc2, enc3, enc4 = "";
                let i = 0;
                do {
                    chr1 = input.charCodeAt(i++);
                    chr2 = input.charCodeAt(i++);
                    chr3 = input.charCodeAt(i++);
                    enc1 = chr1 >> 2;
                    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                    enc4 = chr3 & 63;
                    if (isNaN(chr2)) {
                        enc3 = enc4 = 64;
                    } else if (isNaN(chr3)) {
                        enc4 = 64;
                    }
                    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2)
                        + keyStr.charAt(enc3) + keyStr.charAt(enc4);
                    chr1 = chr2 = chr3 = "";
                    enc1 = enc2 = enc3 = enc4 = "";
                } while (i < input.length);

                return output;
            },
            onSearch(){
                this.list = [];
                this.page = 1;
                this.showtitle=false;
                this.show=true;
                this.searchShowPop=false;
                this.onLoad();
            },
            bindQRCode(){
                new QRCode(this.$refs.qrCodeDiv,{
                    text:this.qrcodeContent,
                    width:200,
                    height:200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
                })

            },
            onLoad(){

                let param = {
                    keywords:this.searchValue.keywords,
                    startDate:this.searchValue.startDate,
                    endDate:this.searchValue.endDate,
                    status:this.searchValue.status,
                    deliveryName:localStorage.getItem("personName"),
                    deliveryIdnumber:localStorage.getItem("deliveryIdnumber"),
                    limit:10,
                    page:this.page
                }
                service.ladingBillList(param).then((res)=>{
                    if(res.code=="200"){
                        if(res.data.length>0){
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        }else{
                            this.finished = true;
                        }


                            // 加载状态结束
                        this.loading = false;
                        this.isLoading=false;
                    }else{
                        this.loading = false;
                        this.finished = true;
                        this.isLoading=false;
                        Toast(res.message)
                    }

                }).catch((res)=>{
                    this.loading = false;
                    this.finished = true;
                    Toast(res.message)
                });
            },
            searchPop(){
                this.show = true;
                // this.showtitle = false;
                // this.title = "筛选";
                // this.searchValue= {keywords:"", from:"", to:"", status:"0"};
                this.searchShowPop = true;
            },
            showBill(item){
                this.outnotify=item
                this.showpop = true;
            },
            closeShow(){
                if(this.ershow)
                {
                    this.ershow=false
                }
                else
                {
                    this.showpop=false;
                    this.show=true;
                }

            },
            onRefresh(){
                this.onLoad();

            },
            remove(id){
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定要删除这条车辆信息吗？',
                    confirmButtonColor:"#6685a4"
                })
                    .then(() => {
                        let param = {
                            "deliveryTruckId":id,
                        }
                        service.deleteTruck(param).then((res)=>{
                            if(res.code=="200"){
                                this.showpop = false;
                                this.page = 1;
                                this.list = [];
                                this.onLoad();
                            }else{
                                Toast(res.msg)
                            }

                        }).catch((res)=>{
                            Toast(res.message)
                        });
                    })
                    .catch(() => {
                        // on cancel
                    });
            },
            //日期组件
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            calendarConfirm(date){
                const [start, end] = date;
                this.calendarShow = false;
                this.searchValue.from = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                this.searchValue.startDate = this.formatDate(start);
                this.searchValue.endDate = this.formatDate(end);

            },
            resetSearch(){
                this.searchValue= {keywords:"",
                    startDate:"",
                    endDate:"",
                    status:20,
                    deliveryName:this.$store.username,
                    deliveryIdnumber:this.$store.deliveryIdnumber};
            },
            showDetail(){
                this.showDetailpop = true;
                this.title = "提货明细"
                let param = {
                    outnotifyId  :this.outnotify.outnotifyId
                };
                service.ladingBillDetail(param).then((res)=>{
                    this.outnotifyDetail=res.data;
                })
            },
            closeDetailShow(){
                this.showDetailpop = false;
                this.title = "提货详情"
            },
            showWarrantyBook(){
                this.showWarrantypop = true;
                this.title = "质保书"
            },
            closeWarrantyShow(){

                    this.showWarrantypop = false;
                    this.title = "提货详情"


            },
            showImg(item){
                ImagePreview([item]);
            },
            closeCurrentPage(){

            }
        }
    }
</script>

<style scoped>
 .van-popup{
     background-color: #f7f8fa;
 }
    .searchwarp{
        margin-top: 46px;
    }
    .editwarp{
        width:100%;
        margin: 56px auto;
    }
    .editwarp .swipewarp{
        margin-bottom: 10px;
    }
    .contentwarp{
        margin-top:50px;
        height: calc(100vh - 50px);
    }
    .detailHeader{
        background-color: #1989fa;
        height:70px;
        text-align: center;
        padding-top: 20px;
        margin-bottom: 20px;
        color:white;
        border-top-right-radius:10px;
        border-top-left-radius:10px;
        border-bottom-right-radius:10px;
        border-bottom-left-radius:10px;
    }
    .detailLabel{
        color: #727272;
    }
    .detailLabel.detailtitle{
        color: #323233;
        font-weight: bold;
    }
    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text ,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow{
        color: #6685a4 ;
    }
    /deep/ .van-button--info ,
    /deep/ .van-button--danger{
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color:#6685a4;
    }

 /deep/ .van-button--warning{
     background-color: #6685a4 ;
     border: 1px solid #6685a4 ;
 }
 /deep/ .ewm .van-button--info {
 border: 1px solid #6685a4 ;
 width: 200px}



    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end ,
    /deep/ .detailHeader[data-v-1405fac1]{
        background-color: #6685a4;
    }
    /deep/  .van-calendar__day--middle{
        background-color: #e4ebf3;
    }
    /*.van-cell::after{
        border-bottom: none;
    }*/
    .van-icon.van-icon-arrow{
        vertical-align: middle;
        margin-left: 5px;
    }
    .van-grid{
        padding:10px;
    }
    /deep/ .van-image__img{
        border: #e4ebf3 1px solid;
    }

    .closebutton{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        /*font-size: 12px;*/
        z-index: 9999;
    }


 .van-divider{
     margin: 0px !important;
 }


 /deep/ .thmx > .van-row{
     padding-top: 10px;
     padding-bottom: 10px;
 }
 /deep/ .van-cell__value.van-cell__value--alone > .thmx:last-child > .van-row{
     padding-top: 10px;
     padding-bottom: 0;
 }
 .button{
     font-size: 16px;
     color: #ffffff;
     background: #6685a4;
     height: 32px;
 }
 .van-button--small {
     padding: 0 15px;
 }
 .van-hairline--surround::after {
     border:none;}
 .van-button--hairline {
     border-width: 1px;
 }
</style>